import {
  useEnabledFeatures as enabledFeaturesHook,
  useFlag as flagHook,
} from '@calendly/feature-check-react'

import { PRODUCT_REFRESH_GLOBAL_FLAG_KEY } from '../shell_layout/shellConstants'

/**
 * Beta cohort flag (`ap_product_refresh_2026_global`) from bootstrap `enabled_features`.
 */
export function useProductRefreshGlobalBetaEnabled(shouldTrack: boolean = false): boolean {
  const enabledFeatures = typeof enabledFeaturesHook === 'function'
    ? enabledFeaturesHook()
    : {}
  const fromBootstrap = enabledFeatures[PRODUCT_REFRESH_GLOBAL_FLAG_KEY] === 'on'
  const fromFlag = typeof flagHook === 'function'
    ? flagHook(PRODUCT_REFRESH_GLOBAL_FLAG_KEY, shouldTrack)
    : false
  return fromBootstrap || fromFlag
}
